import { AfterViewInit, Directive, ElementRef, EventEmitter, Input, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { takeUntil } from 'rxjs/operators';
import { AnessaTranslationService } from './anessa-translation.service';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[anessaTranslation]'
})
export class AnessaTranslationDirective implements AfterViewInit {
  /**
   * Path to json object must be provided with the following parameter
   * in the following format
   *
   * ex. RESULTS.TECHNICAL - each layer in the json object is separated by a period
   */
  @Input() anessaTranslation?: string;
  @Input() params: object = {};

  el: ElementRef;
  onDestroyNotifier = new EventEmitter();

  constructor(
    el: ElementRef,
    private sanitizer: DomSanitizer,
    private translationService: AnessaTranslationService,
  ) {
    this.el = el;
  }

  ngAfterViewInit() {
    this.set();

    this.translationService.languageChangeNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe(() => {
        this.set();
      });
  }

  private set() {
    this.el.nativeElement.innerHTML = this.sanitizer.sanitize(
      SecurityContext.HTML,
      this.translationService.get(this.anessaTranslation, this.params)
    );
  }
}
